"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default(_ref) {
  var active = _ref.active;
  return (
    /*#__PURE__*/
    //background: active ? '#eee' : '#fff',
    _react.default.createElement("div", {
      style: {
        backgroundColor: '#f8f8f8',
        padding: '2pt',
        borderRadius: 2,
        height: '34pt',
        width: '34pt'
      }
    }, /*#__PURE__*/_react.default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24pt",
      height: "34pt",
      viewBox: "0 0 24 34",
      version: "1.1"
    }, /*#__PURE__*/_react.default.createElement("g", {
      id: "surface1"
    }, /*#__PURE__*/_react.default.createElement("path", {
      d: "M 16.652344 15.230469 L 15.890625 16.207031 L 21.140625 18.820312 L 12.007812 23.574219 L 2.839844 18.8125 L 8.164062 16.179688 L 7.394531 15.207031 L 0 18.867188 L 12.074219 33.992188 L 23.925781 18.867188 Z M 21.453125 20.03125 L 12.0625 32.015625 L 2.464844 19.984375 L 12 24.953125 "
    }), /*#__PURE__*/_react.default.createElement("path", {
      d: "M 12.007812 0 L 0.0078125 5.941406 L 7.394531 15.207031 L 8.164062 16.179688 L 12.074219 21.078125 L 15.878906 16.214844 L 16.644531 15.242188 L 23.917969 5.953125 Z M 12 1.363281 L 21.132812 5.917969 L 12 10.667969 L 2.839844 5.898438 Z M 15.53125 14.671875 L 14.769531 15.648438 L 12.074219 19.09375 L 9.296875 15.609375 L 8.523438 14.636719 L 2.472656 7.0625 L 12.007812 12.03125 L 21.453125 7.117188 Z M 15.53125 14.671875 "
    }))))
  );
};

exports.default = _default;